import type { Maybe } from '@/types'

export const getFullName = (firstName: Maybe<string>, lastName: Maybe<string>): string => {
  const items = [firstName, lastName]
  const preparedItems: string[] = []
  items.forEach((t) => {
    if (!t) {
      return
    }
    preparedItems.push(t.trim())
  })

  if (preparedItems.length !== 0) {
    return preparedItems.join(' ').trim()
  }

  return ''
}
